import React, { useEffect, useState } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _, { round } from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "../../../../../animations/worldcup/heatmap";
import { engine as anime } from "../../../../../animations";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import * as d3 from "d3";
import Image from "../../../../shared/components/Image";

require("./style/style.scss");
require("./style/animation.scss");

import {
  positionTranslations,
  positionExtension,
} from "../../../../shared/utils/opta/player";
import { useTranslation } from "react-i18next";
import { getPlayerPosition } from "../../../../shared/utils/players";
import {
  getPlayerHeatmapStats,
  getPlayerStats,
} from "../../../../shared/utils/opta/statsHandler";
import {
  getShortPlayerName,
  getShortPlayerNamer,
} from "../../../../shared/feeds/worldcup/playerHelper";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import { Trikot } from "../../../assets/svg/Trikot";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { PlayerTriko } from "../../_partials/PlayerTriko/Index";

const COLS = 20;
const ROWS = 18;

function parseHeatmap(str) {
  const cells = [];

  for (let row = 0; row < ROWS; row++) {
    for (let col = 0; col < COLS; col++) {
      const index = row * COLS + col;

      cells.push({
        x: col,
        y: row,
        value: Number(str[index]),
      });
    }
  }

  return cells;
}

function heatmapToPoints(str) {
  const cells = parseHeatmap(str);

  const points = [];

  cells.forEach(cell => {
    // for (let i = 0; i < cell.value; i++) {
    //   points.push({
    //     x: (cell.x / COLS) * 100,
    //     y: (cell.y / ROWS) * 100,
    //   });
    // }

    for (let i = 0; i < cell.value; i++) {
      points.push({
        x:
          ((cell.x + 0.5) / COLS) * 100 +
          (Math.random() - 0.5) * 3,

        y:
          ((cell.y + 0.5) / ROWS) * 100 +
          (Math.random() - 0.5) * 3,
      });
    }
  });

  return points;
}

function renderHeatmap(heatmapString, id) {
  const COLS = 20;
  const ROWS = 18;

  // Parse encoded heatmap into weighted points
  const points = [];

  for (let row = 0; row < ROWS; row++) {
    for (let col = 0; col < COLS; col++) {
      const index = row * COLS + col;
      const value = Number(heatmapString?.[index] || 0);

      if (value > 0) {
        points.push({
          x:
            ((col + 0.5) / COLS) * 100 +
            (Math.random() - 0.5) * 3,

          y:
            ((row + 0.5) / ROWS) * 100 +
            (Math.random() - 0.5) * 3,

          value,
        });
      }
    }
  }
  // Remove previous SVG
  d3.select(`#heatmap-${id} svg`).remove();

  // Pitch size
  const margin = { top: 50, right: 50, bottom: 50, left: 50 },
    width = 891 - margin.left - margin.right,
    height = 577 - margin.top - margin.bottom;

  // Create SVG
  const svg = d3
    .select(`#heatmap-${id}`)
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);

  // =========================
  // DEFINITIONS / FILTERS
  // =========================

  // =========================
  // SCALES
  // =========================

  const x = d3
    .scaleLinear()
    .domain([0, 100])
    // .range([margin.left, width - margin.right]);
    .range([0, width]);

  const y = d3
    .scaleLinear()
    .domain([0, 100])
    // .range([height - margin.bottom, margin.top]);
    .range([height, 0])

  // =========================
  // DENSITY
  // =========================

  const densityData = d3
    .contourDensity()
    .x(d => x(d.x))
    .y(d => y(d.y))
    .weight(d => d.value)
    .size([width, height])
    .bandwidth(8)
    .thresholds(24)
    .cellSize(2)(points);

  // =========================
  // COLOR SCALE
  // =========================

  // const color = d3
  //   .scaleLinear()
  //   .domain([0, 0.1, 0.15, 0.2, 0.3, 0.45, 0.65])
  //   .range(["lightgreen", "green", "yellow", "orange", "red", "darkred"]);

  const values = densityData.map(d => d.value).sort(d3.ascending);

  const q = [
    d3.quantile(values, 0.0),
    d3.quantile(values, 0.2),
    d3.quantile(values, 0.4),
    d3.quantile(values, 0.6),
    d3.quantile(values, 0.8),
    d3.quantile(values, 1.0)
  ];

  const color = d3.scaleLinear()
    .domain(q)
    .range([
      "lightgreen",
      "green",
      "yellow",
      "orange",
      "red",
      "darkred"
    ]);

  // =========================
  // HEATMAP LAYER
  // =========================

  const paths = svg
    .insert("g", "g")
    .selectAll("path")
    .data(densityData)
    .enter()
    .append("path")
    .attr("d", d3.geoPath())
    .attr("stroke", "transparent")
    .attr("stroke-width", 0)
    .attr("fill", function (d) {
      return color(d.value);
    });

  return {
    paths,
  };
}

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const [heatmapReturn, setHeatmapReturn] = useState();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }

      if (heatmapReturn?.timeouts) {
        animationCleanUp(heatmapReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;

  const matchInfo = _.get(dynamic, "matchInfo");
  const playerStats = _.get(dynamic, "topPlayer");
  const heatmap = _.get(playerStats, "Heatmap", "");
  const teamSide = getContentById("selectedSide", fields);

  const backgroundImage = getMainBackground(format, teamSide);

  const homeTeam = matchInfo?.TeamStatistic?.[0];
  const awayTeam = matchInfo?.TeamStatistic?.[1];


  const competitionId = matchInfo?.competition?.id;

  // const targetAlpha = teamSide === "home" ? teamHomeAlpha2 : teamAwayAlpha2;
  const targetAlpha = teamSide === "home" ? homeTeam?.TeamId : awayTeam?.TeamId;

  const playerHome = playerStats;

  // const homeStats = _.get(playerHome, "stat", []);
  // const playerStatsParsed = getPlayerHeatmapStats(homeStats);
  const kits = _.get(dynamic, "kits");


  useEffect(() => {
    if (heatmap !== "") {
      const heatmapOut = renderHeatmap(heatmap, id, animation);
      setHeatmapReturn(heatmapOut);
    }
  }, [heatmap]);

  useEffect(() => {
    if (heatmapReturn && animation) {
      const { paths } = heatmapReturn;
      const stagger = 80; // Adjust this value to control the stagger effect

      const totalAnimationDuration = 1200; // Total duration of animation in milliseconds

      paths.each(function (d, i) {
        const path = d3.select(this);
        const totalLength = path.node().getTotalLength();

        path
          .attr("stroke-dasharray", totalLength + " " + totalLength)
          .attr("stroke-dashoffset", totalLength)
          .attr("opacity", "0"); // Start with opacity 0
      });

      const timeout1 = setTimeout(() => {
        paths.each(function (d, i) {
          const path = d3.select(this);
          const totalLength = path.node().getTotalLength();

          // Create an anime.js animation
          anime({
            targets: path.node(),
            strokeDashoffset: [totalLength, 0],
            opacity: [0, 1],
            // translateX: [-200, 0],
            // scale: [2, 1],
            // scale: [0, 1],
            duration: totalAnimationDuration,
            delay: i * stagger, // Use the stagger value here
            // easing: "easeOutQuint",
            easing: "easeOutSine",
          });
        });
      }, 1200);
    }
  }, [heatmapReturn, animation]);

  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""
        } side-${teamSide}`}
    >
      <TemplateBlock>
        <Backgrounds bg1={backgroundImage} loop={true} />
        {/*<WcBgCircle />*/}

        <div className={"wc-content wc-content-v2"}>
          <ProgressBar height={"8px"} strokeColor="#177C76" />
          <div className={"wc-bg-content"}></div>

          <div className={"dfb-tv-logo"}>
            <img src={assets.sd_dfb_tv_logo} />
          </div>

          <div className={"left-block-side"}>
            <div className={"main-headline"}>{t("Heatmap", {})}</div>

            <div className={"teams-block"}>
              <PlayerTriko
                className={"player-position"}
                player={playerHome}
                teamId={targetAlpha}
                side={teamSide}
                bgColor={kits?.[teamSide]?.colour1}
                team={teamSide === 'home' ? homeTeam : awayTeam}
                competitionId={competitionId}
              />
            </div>
          </div>

          <div className={"right-block-side"}>
            <div className={"heatmap-block"}>
              <div className={"pitch-container"}>
                <div id={`heatmap-${id}`} className={`player-heatmap`}></div>
                <img className={"heatmap-pitch"} src={assets.heatmap_pitch_fcb} />
                <div className={`arrows-right direction-${teamSide === "home" ? "right" : "left"}`}>
                  <img src={assets.right_arrow} />
                  <img src={assets.right_arrow} />
                  <img src={assets.right_arrow} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className={"stats-block"}>
          {playerStatsParsed.map((statRowHome, index) => {
            return (
              <React.Fragment key={"stats1" + statRowHome.type}>
                <div className={`stat-row`}>
                  <div className={"stat-label"}>
                    {t(statRowHome?.type, { keyPrefix: "stats" })}
                  </div>
                  <div className={"stat-value"}>
                    {statRowHome?.value || "0"}
                  </div>
                </div>
                {index < playerStatsParsed.length - 1 && (
                  <div className={"stat-separator"}></div>
                )}
              </React.Fragment>
            );
          })}
        </div> */}
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `sd_background_split`);
};

export default Index;
